import React, { useState, useEffect } from 'react'
import axios from 'axios'

// Just show the equipment and modules in the admin view...

const Modules = (props) => {

  const [dbProps, setDbProps] = useState([])
  const [sfProps, setSfProps] = useState([])
  const [batchOneProps] = useState([])
  const [batchTwoProps] = useState([])
  const [batchThreeProps] = useState([])
  const [batchFourProps] = useState([])
  const [batchFiveProps] = useState([])
  const [batchSixProps] = useState([])

  const { make, model, ptcRating, size } = props.module

  const getDbProps = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'get_back_fill_db' })
      .then((res) => {
        console.log(res.data)
        return setDbProps(res.data.data)
      })
  }

  const getSfProps = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'get_back_fill' })
      .then((res) => {
        console.log(res.data)
        return setSfProps(res.data.data)
      })
  }

  const batchOne = () => {
    dbProps.forEach(function (i) {
      sfProps.forEach(function (j) {
        if(i.projectId === j.id){
          batchOneProps.push(i)
        }
      })
    })
  }

  const batchTwo = () => {
    batchOneProps.forEach(function (i) {
      sfProps.forEach(function (j) {
        if (i.projectId === j.id && +i.netCost === +j.netCost && +i.grossCost === +j.grossCost){
          batchTwoProps.push(i)
        }
      })
    })
  }


  const batchThree = () => {
    batchTwoProps.forEach(function (i) {
      sfProps.forEach(function (j) {
        if (i.projectId === j.id && +i.systemSize === +j.systemSize){
          batchThreeProps.push(i)
        }
      })
    })
  }

  const batchFour = () => {
    batchThreeProps.forEach(function (i) {
      sfProps.forEach(function (j) {
        if (i.projectId === j.id && +i.offset === +j.offset){
          batchFourProps.push(i)
        }
      })
    })
  }

  const batchFive = () => {
    batchFourProps.forEach(function (i) {
      sfProps.forEach(function (j) {
        if (i.projectId === j.id && +i.production === +j.production){
          batchFiveProps.push(i)
        }
      })
    })
  }

  const batchSix = () => {
    batchFiveProps.forEach(function (i) {
      sfProps.forEach(function (j) {
        // console.log(`"${i.loan1}" "${i.term1}yr ${i.interest1}%"`, `${j.financingSource} ${j.financingProduct}`)
        if (i.projectId === j.id && `${i.loan1} Single ${i.term1}yr ${i.interest1}%` === `${j.financingSource} ${j.financingProduct}`){
          batchSixProps.push(i)
        }
        if (i.projectId === j.id && `${i.loan2} Single ${i.term2}yr ${i.interest2}%` === `${j.financingSource} ${j.financingProduct}`){
          batchSixProps.push(i)
        }
      })
    })
  }

  //START WITH THE PPWS NEXT

  // console.log(dbProps)
  // console.log(sfProps)
  // console.log(batchOneProps)
  // console.log(batchTwoProps)
  // console.log(batchThreeProps)
  // console.log(batchFourProps)
  // console.log(batchFiveProps)
  // console.log(batchSixProps)

  return (
    <>
      <div className='items'>
        <p>{make} {model} {size} watt</p>
        <span>PTC Rating: {ptcRating}</span>
      </div>
      {/* <div>
        <button onClick={() => getDbProps()}>Get DB Props</button>
        <button onClick={() => getSfProps()}>Get SF Props</button>
        <button onClick={() => batchOne()}>Batch 1 - id</button>
        <span> {batchOneProps.length}</span>
        <button onClick={() => batchTwo()}>Batch 2 - cost</button>
        <span> {batchTwoProps.length}</span>
        <button onClick={() => batchThree()}>Batch 3 - system size</button>
        <span> {batchThreeProps.length}</span>
        <button onClick={() => batchFour()}>Batch 4 - offset</button>
        <span> {batchFourProps.length}</span>
        <button onClick={() => batchFive()}>Batch 4 - production</button>
        <span> {batchFiveProps.length}</span>
        <button onClick={() => batchSix()}>Batch 4 - loanOptions</button>
        <span> {batchSixProps.length}</span>
      </div> */}
    </>

  )
}
export default Modules